import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../../../../constants/common'
import { getActionSelectOptions } from '../../../../../../Action'

export function useRentalPortalListingsBoardCardActions({
  getActions,
  item,
  onCallAction,
}) {
  const { t } = useTranslation()

  const actions = getActionSelectOptions({
    actions: getActions?.(item) ?? EMPTY_LIST,
    t,
  })

  function handleClickAction(action) {
    onCallAction?.(action?.value, item)
  }

  return { actions, handleClickAction }
}
